import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useLocalizedHref } from "@/hooks/useLocalizedHref";

/**
 * Locale-aware 404 page. Mounted via the router's `defaultNotFoundComponent`,
 * so both /missing-thing and /fr/missing-thing land here. Body copy is driven
 * by the i18n catalog, so it follows the active locale automatically.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const href = useLocalizedHref();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-6 py-24 text-center">
      <p className="font-mono text-sm tracking-widest text-neutral-500 uppercase">
        {t("notFound.eyebrow")}
      </p>
      <h1 className="mt-4 font-serif text-5xl tracking-tight md:text-7xl">{t("notFound.title")}</h1>
      <p className="mt-6 max-w-md text-balance text-neutral-600">{t("notFound.description")}</p>
      <Link
        to={href("/")}
        className="mt-10 inline-flex items-center gap-2 rounded-full bg-neutral-900 px-6 py-3 text-sm font-medium text-white transition hover:bg-neutral-700"
      >
        {t("notFound.cta")}
      </Link>
    </main>
  );
}
